export default "__VITE_ASSET__CvY5es7___"